import useJwt from '@/auth/jwt/useJwt'

export class AuthService {
  static formatUserAbility(scope) {
    if (!scope || !scope.length) return []
    return scope.map((item) => ({
      action: 'ROLE_' + item,
      subject: 'ACL'
    }))
  }

  static formatUserData(user, scope) {
    return {
      id: user.id,
      email: user.email,
      nome: user.firstName,
      username: user.firstName,
      fullName: `${user.firstName} ${user.lastName}`,
      role: user.perfil.nome,
      ability: this.formatUserAbility(scope),
      extras: {
        eCommerceCartItemsCount: 1
      }
    }
  }

  static async fetchAndSetupUser(userId, scope) {
    const response = await useJwt.getUsersById(userId)
    const userData = this.formatUserData(response.data, scope)
    localStorage.setItem('userData', JSON.stringify(userData))
    return userData
  }

  static getLoginErrorMessage(error) {
    let errorDesc = null
    let errorTitle = null

    // Pega a descrição do erro do payload do axios ou do objeto direto
    if (error?.response?.data?.error_description) {
      errorDesc = error.response.data.error_description
      errorTitle = error.response.data.error
    } else if (error?.error_description) {
      errorDesc = error.error_description
      errorTitle = error.error
    } else if (error?.error) {
      errorDesc = error.error_description
      errorTitle = error.error
    }

    if (errorDesc && typeof errorDesc === 'string') {
      const lowerDesc = errorDesc.toLowerCase()
      // Se for bad credentials (senha errada ou usuario invalido)
      if (lowerDesc.includes('invalid') || lowerDesc.includes('credenciais') || lowerDesc.includes('bad credentials')) {
        return 'Email ou Senha Incorretos'
      }
      
      // Validação de fallback para o erro 'invalid_grant'
      if (errorTitle === 'invalid_grant') {
        return 'Email ou Senha Incorretos'
      }
      
      // Se vier outra mensagem de erro que não mapeamos acima, exibe
      return errorDesc
    }

    return 'Erro ao tentar realizar o login. Tente novamente mais tarde.'
  }
}
